<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <!-- <img src="@/assets/img/logo_footer.png" alt="logo-footer"> -->
      <img src="@/assets/img/ltlogo-footer.png" alt="logo-footer">
    </div>
    <p class="title">Lantech Automation</p>
    <p class="address_tel_fax">
      <span>Address：UNIT 20, 300 STEELCASE, MARKHAM, ON, CANADA</span>
      <!-- <br> -->
      <!-- <span>Fax：8888-88888888</span> -->
    </p>
    <p class="address_tel">
      <span> Tel：1-647-898-3518</span>
      <!-- <span>Fax：8888-88888888</span> -->
    </p>
    <p class="email_wx">
      <span>E-Mail：info@lantechautomation.com</span>
      <!-- <span>Facebook：ilyk_gg</span> -->
    </p>
    <p class="copy">Copyright &copy; 2008 - 2024 Lantech Automation</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: url("../assets/img/contactus.png") 0 0 no-repeat;
  /* background: #00729d; */
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 70px;
  margin: 50px auto 20px;
}
.logo img{
  width: 100%;
  height: 100%;
}
.title {
  font-size: 30px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #F6F8ED;
  font-size: 18px;
  margin: 10px 0;
}
.address_tel {
  color: #F6F8ED;
  font-size: 18px;
  margin: 10px 0;
}
.email_wx {
  color: #F6F8ED;
  font-size: 18px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue